import { Injectable, RendererStyleFlags2 } from '@angular/core';
import { ProfileSelectorHelperComponent } from './profile-selector-helper.component';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorSupportComponent extends ProfileSelectorHelperComponent {
  innerWidth!: number;
  advisorBanner = false;
  fromStandAlonePage = false;
  queryParamKeys: string[] = [];
  paramsToIgnore: string[] = [];
  queryParams = {} as { [key: string]: string };

  assignRefreshURL(): void {
    if (this.fromStandAlonePage) {
      this.refreshURL = this.profileSelectorFacadeService.refreshURL;
      this.paramsToIgnore = this.profileSelectorFacadeService.paramsToIgnore;
      this.queryParamKeys = this.profileSelectorFacadeService.queryParamKeys;
      this.queryParams = this.profileSelectorFacadeService.queryParams;
    }
  }

  setStyleForStandalone(loginModal: HTMLElement, headerHeight: number): void {
    if (this.fromStandAlonePage) {
      const navbar = document.querySelector('.navbar');
      const footer = document.querySelector('.fresh-air .hp-footer');
      const footerInfo = footer?.querySelector('.footer-info p');
      const loginModalDiv = document.querySelector('.profile-selector-smart');
      const rendererFlags =
        RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
      this.renderer.setStyle(navbar, 'position', 'relative');
      this.renderer.setStyle(navbar, 'flex-wrap', 'nowrap');
      this.renderer.setStyle(loginModal, 'top', '0');
      this.renderer.setStyle(loginModal, 'position', 'relative');
      this.renderer.setStyle(loginModal, 'margin-top', `${headerHeight}px`);
      this.renderer.setStyle(loginModal, 'margin-right', '0');
      this.renderer.setStyle(
        footer,
        'background-color',
        'transparent',
        rendererFlags
      );
      this.renderer.setStyle(footerInfo, 'color', '#f8f8f8');
      this.renderer.setStyle(loginModalDiv, 'max-height', 'none');
    }
  }

  checkAlertAdvisorContainer(): void {
    this.advisorBanner = !!document.querySelector(
      '.alert-advisory-main-container'
    );
  }

  getInnerWidth(): void {
    this.innerWidth = window.innerWidth;
  }

  onClickLogout(): void {
    this.profileSelectorFacadeService.logout();
  }

  focusTab(focusable: HTMLElement[], e: KeyboardEvent): void {
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const shift = e.shiftKey;
    if (shift) {
      if (e.target === first) {
        last.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === last) {
        first.focus();
        e.preventDefault();
      }
    }
  }

  initializeDataForStandAlonePage(
    enableMachCore: boolean,
    setModalPropertiesCallback?: () => void
  ): void {
    if (this.profileSelectorFacadeService.fromProfileStandAlone$.value) {
      this.fromStandAlonePage = true;
      this.profileSelectorFacadeService.enableProfileSelector(
        this.fromStandAlonePage
      );
      this.defaultSelectAccount(
        (this.profileSelectorAdapterHelperService.firstName = ''),
        'P',
        0
      );
      if (setModalPropertiesCallback) {
        setModalPropertiesCallback();
      }
      this.assignRefreshURL();
    } else {
      if (enableMachCore) {
        this.profileSelectorFacadeService.enableProfileSelector(false);
      }
    }
  }

  setupModalProperties(): void {
    this.checkAlertAdvisorContainer();
    this.modalContainerFocus();
    this.getInnerWidth();
  }

  handleResizeOperations(): void {
    this.getInnerWidth();
    this.checkAlertAdvisorContainer();
  }
}
